import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { RightIcon } from 'foundations-assets';
import unescapedText from 'I18n/utils/unescapedText';
import MainSection from 'marketplace-ui-common/layout/components/MainSection';
import { usePublishedCollections } from 'marketplace-ui-common/collections/hooks/usePublishedCollections';
import { useIsActiveRoute } from '../../../hooks/useIsActiveRoute';
import { getModulesStorefrontRoute, getThemesStorefrontRoute } from '../../../utils/urls';
import MobileBrowsePanel from './MobileBrowsePanel';
import { getIsInApp } from '../../../selectors/app';
import { useOfferingType } from '../../../context/OfferingTypeContext';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const stripTrailingSlash = path => {
  if (path === '/') return path;
  if (!path.endsWith('/')) return path;
  return path.slice(0, -1);
};
function BrowseTitle() {
  const location = useLocation();
  const isInApp = useSelector(getIsInApp);
  const appContext = isInApp ? 'app' : 'public';
  const offeringType = useOfferingType();
  const {
    getDisplayedCollections
  } = usePublishedCollections({
    appContext,
    offeringType
  });
  const publishedCollections = getDisplayedCollections();
  const currentPath = stripTrailingSlash(location.pathname);
  const collection = publishedCollections.find(_collection => _collection.publishedListing && getThemesStorefrontRoute(_collection.publishedListing.slug) === currentPath);
  const isActiveModuleRoute = useIsActiveRoute(getModulesStorefrontRoute(), false);
  let title = unescapedText('marketplace-assets-ui.storefront.nav.themes');
  if (collection && collection.publishedListing) {
    title = collection.publishedListing.title;
  } else if (isActiveModuleRoute) {
    title = unescapedText('marketplace-assets-ui.storefront.nav.modules');
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.storefront.nav.browse",
    options: {
      title
    }
  });
}
export default function MobileBrowseBar() {
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const mobileBrowseBarRef = useRef(null);
  const handlePanelCloseComplete = () => {
    mobileBrowseBarRef.current.focus();
  };
  return /*#__PURE__*/_jsxs(MainSection, {
    paddingBlock: "300",
    color: "light",
    responsive: true,
    children: [/*#__PURE__*/_jsx(Clickable, {
      buttonRef: mobileBrowseBarRef,
      onClick: () => {
        setIsPanelOpen(true);
      },
      onKeyDown: event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          setIsPanelOpen(true);
        }
      },
      tabIndex: 0,
      children: /*#__PURE__*/_jsxs(TFlex, {
        children: [/*#__PURE__*/_jsx(BrowseTitle, {}), /*#__PURE__*/_jsx(View, {
          as: "span",
          marginInlineStart: "auto",
          children: /*#__PURE__*/_jsx(RightIcon, {
            color: "do-not-use-calypso",
            size: "600"
          })
        })]
      })
    }), /*#__PURE__*/_jsx(MobileBrowsePanel, {
      onClose: () => {
        setIsPanelOpen(false);
        handlePanelCloseComplete();
      },
      open: isPanelOpen
    })]
  });
}